export default __webpack_public_path__ + "media/images/green_check-4b20d45025550291177c8a5524e395ef.png";